module.exports = __webpack_public_path__ + "img/drag.e4a68d44.svg";